import React from "react";
import moment from "moment";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import LinkSharingOptions from "./LinkSharingOptions";
import {
  SHARE_LINK_NOT_PUBLISHED_NOTE,
  SHARE_LINK_END_DATE_PASSED_NOTE,
} from "./shareCopy";

// TBV-951: a Trivvy's Copy Link sharing options in the list Copy Link modal.
// Same rules as the Share page: editable only while the Trivvy is sharable,
// User Must Provide needs a Premium+ plan, and changes save via editTrivia.
const TrivvyLinkSharingOptions = ({ trivvy, user, onUpdated }) => {
  const isEndDatePassed =
    Boolean(trivvy.trivvyEndDate) && moment(trivvy.trivvyEndDate).isBefore(moment());
  const isSharable =
    !isEndDatePassed &&
    Boolean(
      trivvy.isPublished ||
        (trivvy.isMessaging === true && trivvy.otherMediumsShareCount < 1)
    );
  const planInvalid =
    user.profile && user.profile.organizationId
      ? ["001", "002"].includes(user.profile.organizationId.trivvyPlanType)
      : false;

  let notice = "";
  if (isEndDatePassed) {
    notice = SHARE_LINK_END_DATE_PASSED_NOTE;
  } else if (!isSharable) {
    notice = SHARE_LINK_NOT_PUBLISHED_NOTE;
  }

  return (
    <LinkSharingOptions
      initialPrivacy={trivvy.privacy}
      initialUserIdentification={
        trivvy.userIdentificationOptions && trivvy.userIdentificationOptions[0]
      }
      disabled={!isSharable}
      planInvalid={planInvalid}
      notice={notice}
      saveSettings={(updateData) =>
        axios.put(url.editTrivia(trivvy._id), { updateData })
      }
      onSaved={(updateData) => {
        if (onUpdated) {
          onUpdated(trivvy._id, updateData);
        }
      }}
    />
  );
};

export default TrivvyLinkSharingOptions;
